import { useQuery } from '@tanstack/react-query'
import { api } from '@/utils/api'
import { apiWhatsappApiBalance } from '@/utils/api/url'
import { WhatsappApiBalance } from '@/types/whatsappApi'

export const QUERY_KEY_WHATSAPP_BALANCE = 'QUERY_KEY_WHATSAPP_BALANCE'

export const useGetWhatsappBalance = ({ enabled = true }: { enabled?: boolean }) =>
  useQuery({
    enabled,
    queryKey: [QUERY_KEY_WHATSAPP_BALANCE],
    queryFn: () => api.get(apiWhatsappApiBalance).then(({ data }) => data as WhatsappApiBalance),
    retry: false,
  })
